import { api } from '../api';
import type { Menu } from '@/types/menu';
import type { DashboardMenusStats } from '@/types/company';

export const menuApi = {
  getAll: () => api.get<Menu[]>('/menus'),
  getById: (id: string) => api.get<Menu>(`/menus/${id}`),
  create: (data: Partial<Menu>) => api.post<Menu>('/menus', data),
  update: (id: string, data: Partial<Menu>) => api.patch<Menu>(`/menus/${id}`, data),
  delete: (id: string) => api.delete(`/menus/${id}`),
  getStats: () => api.get<DashboardMenusStats>(`/menus/stats`),
  getScopedStats: (filters: { organizationId?: number; companyId?: number }) => {
    const params = new URLSearchParams();
    if (filters?.organizationId !== undefined) params.set('organizationId', String(filters.organizationId));
    if (filters?.companyId !== undefined) params.set('companyId', String(filters.companyId));
    const query = params.toString();
    return api.get<DashboardMenusStats>(`/menus/stats${query ? `?${query}` : ''}`);
  },
};
